import Head from 'next/head'
import Script from 'next/script'
import { Faq } from '../../components/commons/Faq';
import { generalFaq } from '../../utils/faq';
import Link from 'next/link'

export default function Home(props) {
  
  return (
    <>
      <Head>
        <title>General FAQs StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Frequently asked questions by people"/>
        <meta name="keywords" content="Frequently asked questions"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/faq" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="General FAQs StringsSG"/>
        <meta property="og:description" content="Frequently asked questions by people" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/faq"/>
        <meta name="twitter:title" content="General FAQs StringsSG"/> 
        <meta name="twitter:description" content="Frequently asked questions by people"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/faq" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [{
                  "@type": "Question",
                  "name": "How to open a service request?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Click on service category you wish to request for on the home page, answer a few questions and submit your request. The process should not take more than 2 minutes."
                  }
                },{
                  "@type": "Question",
                  "name": "How to close a request?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The option to cancel or complete a request is available on the top right corner of your request item. Once you close the request you will not receive any further response from service providers."
                  }
                },{
                  "@type": "Question",
                  "name": "Are StringsSG service providers reliable?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We bring together the best service providers in your area to help you with your requirements."
                  }
                },{
                  "@type": "Question",
                  "name": "How to update my profile information?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Navigate to Account > Settings to manage your profile info."
                  }
                },{
                  "@type": "Question",
                  "name": "How to hide my mobile number?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Navigate to Account > Privacy & Mobile and turn-on 'Hide Mobile Number'."
                  }
                },{
                  "@type": "Question",
                  "name": "How to stop getting emails about my request?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "To stop getting emails regarding your newly opened request, please close the request by logging in to your StringsSG Account."
                  }
                },{
                  "@type": "Question",
                  "name": "Who do I contact for any enquires on my account?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Email us at support@stringssg.com"
                  }
                }]
              }
              `
          }}
        />
      </Head>
        <div className='max-w-5xl mx-auto'>    
            <div className='pt-8 flex justify-end px-6'>
                <Link href="/faq/service-provider" className='text-orange-600 text-sm p-2'>FAQ for Service Providers</Link>
            </div>
            <Faq 
              questionsAnswers={generalFaq}
              title="General FAQs"
            /> 
        </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}